import React from "react"
import Productive from "./productive.png"
import Article from "./Article"
import EmptyBlock from "./EmptyBlock"
import styles from "./BannerHome.module.scss"
import BannerContainer from "@components/BannerContainer"

const BannerRequestApproval = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <Article />
            <EmptyBlock className={styles.emptyBlockLeft} />
          </React.Fragment>
        )
      }}
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <img
              src={Productive}
              alt="Apple Mac Book Laptop"
              className={styles.macbook + " align-items-baseline"}
            />
            <EmptyBlock className={styles.emptyBlockRight} />
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerRequestApproval
